const AccessSection = () => {
  const routeSteps = [
    {
      step: 1,
      description: '近鉄大阪線「五位堂駅」改札を出て、北口へ',
      image: 'https://public.readdy.ai/ai/img_res/a2bb87e472632ff81e96edc113083630.jpg',
    },
    {
      step: 2,
      description: '駅前のロータリーを右手に進み、大通りへ',
      image: 'https://readdy.ai/api/search-image?query=Japanese%20urban%20street%20view%2C%20clean%20city%20road%2C%20modern%20buildings%2C%20simple%20white%20background%2C%20clear%20pathway%2C%20professional%20documentation%20photo%2C%20daytime%20lighting&width=800&height=500&seq=route-002&orientation=landscape',
    },
    {
      step: 3,
      description: 'エー・アイビル202号室に到着（徒歩約2分）',
      image: 'https://readdy.ai/api/search-image?query=Modern%20Japanese%20office%20building%20exterior%2C%20clean%20architecture%2C%20professional%20building%20entrance%2C%20simple%20white%20background%2C%20clear%20building%20signage%2C%20daytime%20lighting&width=800&height=500&seq=route-003&orientation=landscape',
    },
  ];

  return (
    <section className="py-16 md:py-24 bg-gradient-to-b from-light-gold to-white px-4">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-serif font-semibold text-center text-dark-gray mb-12 md:mb-16">
          アクセス
        </h2>

        <div className="grid md:grid-cols-2 gap-8 mb-16">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-md h-80 md:h-96">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3285.123456789!2d135.7058!3d34.5428!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzTCsDMyJzM0LjEiTiAxMzXCsDQyJzIwLjkiRQ!5e0!3m2!1sja!2sjp!4v1234567890"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="LUCIALL 地図"
            ></iframe>
          </div>

          {/* Info */}
          <div className="flex flex-col justify-center">
            <h3 className="text-2xl md:text-3xl font-serif font-semibold text-dark-gray mb-6">
              LUCIALL
            </h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <i className="ri-map-pin-fill w-6 h-6 flex items-center justify-center text-gold text-xl flex-shrink-0"></i>
                <div>
                  <p className="text-dark-gray text-sm md:text-base">
                    〒639-0225<br />
                    奈良県香芝市瓦口158-4<br />
                    エー・アイビル202号室
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-train-fill w-6 h-6 flex items-center justify-center text-gold text-xl flex-shrink-0"></i>
                <p className="text-dark-gray text-sm md:text-base">
                  <strong className="font-semibold">近鉄大阪線「五位堂駅」から徒歩2分</strong><br />
                  駅から大変近く、お仕事帰りやお買い物のついでにも気軽にお立ち寄りいただけます。
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-phone-fill w-6 h-6 flex items-center justify-center text-gold text-xl flex-shrink-0"></i>
                <a href="tel:08091541191" className="text-dark-gray text-sm md:text-base hover:text-gold transition-colors">
                  080-9154-1191
                </a>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-time-fill w-6 h-6 flex items-center justify-center text-gold text-xl flex-shrink-0"></i>
                <p className="text-dark-gray text-sm md:text-base">
                  10:00〜19:00<br />
                  <span className="text-medium-gray text-sm">定休日：不定休</span>
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-bank-card-fill w-6 h-6 flex items-center justify-center text-gold text-xl flex-shrink-0"></i>
                <p className="text-dark-gray text-sm md:text-base">
                  現金・各種クレジットカード・電子マネー
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Route Guide */}
        <div className="bg-white rounded-3xl p-6 md:p-10">
          <h3 className="text-xl md:text-2xl font-serif font-semibold text-dark-gray mb-8 text-center">
            駅からのルート案内
          </h3>
          <div className="space-y-8">
            {routeSteps.map((step) => (
              <div key={step.step} className="flex flex-col md:flex-row gap-6 items-start">
                <div className="flex-shrink-0 w-16 h-16 bg-gold rounded-full flex items-center justify-center text-white text-2xl font-bold">
                  {step.step}
                </div>
                <div className="flex-1">
                  <p className="text-dark-gray mb-4 text-sm md:text-base leading-relaxed">
                    {step.description}
                  </p>
                  <div className="w-full h-48 md:h-64 rounded-xl overflow-hidden bg-light-gold">
                    <img
                      src={step.image}
                      alt={`ルート ${step.step}`}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mt-12 justify-center">
          <a
            href="#reservation"
            className="bg-gold text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-gold/90 transition-colors text-center whitespace-nowrap"
          >
            WEB予約
          </a>
          <a
            href="tel:08091541191"
            className="bg-white text-gold border-2 border-gold px-8 py-4 rounded-full text-base font-semibold hover:bg-light-gold transition-colors text-center whitespace-nowrap"
          >
            電話をかける
          </a>
        </div>
      </div>
    </section>
  );
};

export default AccessSection;
